import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { captureSignal } from './error-telemetry';

let initialized = false;

/** Report a Web Vitals metric through Hyperion's existing same-origin RUM sink. */
export function reportWebVital(metric: Metric): void {
  captureSignal('web.vital', {
    name: metric.name,
    value: metric.value,
    delta: metric.delta,
    rating: metric.rating,
    navigation_type: metric.navigationType,
    metric_id: metric.id,
  });
}
/**
 * Install the five stable Web Vitals observers once per browser page.
 * The library defers callbacks until the browser has a usable measurement;
 * unsupported observers simply produce no signal.
 */
export function initWebVitals(): void {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  onCLS(reportWebVital);
  onFCP(reportWebVital);
  onINP(reportWebVital);
  onLCP(reportWebVital);
  onTTFB(reportWebVital);
}
